import { jsx as e } from "react/jsx-runtime";
import { FormField as r } from "../../../../common/components/FormField.js";
import o from "./index.js";
const l = ({ control: l2, name: n, errorName: a, onInput: i, onChange: t, disabled: d, required: m, preview: u, label: s, hook: p, extraProps: c, loading: v = false, queryFilters: h }) => e(r, { control: l2, name: n, errorName: a, label: s, required: m, disabled: d, preview: u, renderPreview: (e2) => {
  var _a;
  return (_a = e2 == null ? void 0 : e2.value) == null ? void 0 : _a.value;
}, loading: v, children: ({ value: r2, onBlur: l3 }) => e(o, { name: n, placeholder: "Оберіть зі списку", value: r2 || null, onInput: i, onChange: (e2) => t(e2), onBlur: l3, hook: p, disabled: d, extraProps: c, queryFilters: h }) });
export {
  l as default
};
//# sourceMappingURL=AutocompleteWithHook.js.map
